import { FormatBold, FormatItalic, FormatListBulleted, FormatListNumbered, FormatStrikethrough, FormatUnderlined } from '@mui/icons-material';
import { Divider, MenuItem, Select, ToggleButton, ToggleButtonGroup } from '@mui/material';
import Underline from '@tiptap/extension-underline';
import { EditorProvider, useCurrentEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import "./styles.css";

const extensions = [StarterKit, Underline];

const MenuBar = () => {
  const { editor } = useCurrentEditor()

  if (!editor) {
    return null
  }

  return (
    <>
      <div className="flex flex-row items-center gap-2">
        <Select
          size="small"
          value={editor.isActive('paragraph') ? 0 : (editor.getAttributes('heading').level || '')}
          onChange={(e) => {
            if (e.target.value === 0) {
              editor.chain().focus().setParagraph().run()
              return
            }
            editor.chain().focus().toggleHeading({ level: e.target.value }).run()
          }}
        >
          <MenuItem value={0}>Paragraph</MenuItem>
          <MenuItem value={1}>Heading 1</MenuItem>
          <MenuItem value={2}>Heading 2</MenuItem>
          <MenuItem value={3}>Heading 3</MenuItem>
          <MenuItem value={4}>Heading 4</MenuItem>
          <MenuItem value={5}>Heading 5</MenuItem>
          <MenuItem value={6}>Heading 6</MenuItem>
        </Select>
        <ToggleButtonGroup size="small">
          <ToggleButton value="bold" selected={editor.isActive('bold')} onChange={() => editor.chain().focus().toggleBold().run()}>
            <FormatBold />
          </ToggleButton>
          <ToggleButton value="italic" selected={editor.isActive('italic')} onChange={() => editor.chain().focus().toggleItalic().run()}>
            <FormatItalic />
          </ToggleButton>
          <ToggleButton value="underline" selected={editor.isActive('underline')} onChange={() => editor.chain().focus().toggleUnderline().run()}>
            <FormatUnderlined />
          </ToggleButton>
          <ToggleButton value="strike" selected={editor.isActive('strike')} onChange={() => editor.chain().focus().toggleStrike().run()}>
            <FormatStrikethrough />
          </ToggleButton>
        </ToggleButtonGroup>
        <ToggleButtonGroup size="small">
          <ToggleButton value="bulletList" selected={editor.isActive('bulletList')} onChange={() => editor.chain().focus().toggleBulletList().run()}>
            <FormatListBulleted />
          </ToggleButton>
          <ToggleButton value="orderedList" selected={editor.isActive('orderedList')} onChange={() => editor.chain().focus().toggleOrderedList().run()}>
            <FormatListNumbered />
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
      <Divider sx={{ my: 2 }} />
    </>
  )
}

interface RichTextEditorProps {
  initialContent: string;
  setContent: (content: string) => void;
}

const RichTextEditor = ({ initialContent, setContent }: RichTextEditorProps) => {
  return (
    <div className="p-4 bg-white border border-gray-300 rounded-xl">
      <EditorProvider slotBefore={<MenuBar />} extensions={extensions} content={initialContent} onUpdate={({ editor }) => setContent(editor.getHTML())}>
        <></>
      </EditorProvider>
    </div>
  )
}

export default RichTextEditor;
